import angular from 'angular';
import {getDateRanges} from '../../common/datetime/date-ranges';
import ResourcesModule from '../../resources/resources';
import SegmentsDefinitionValidation from './segmentsDefinitionValidation';
import ObservablesModule from '../../services/observables';
import LocalizationModule from '../../configs/localization/localization';
import FiltersModule from '../../filters/filters';
import SegmentsRulesTransform from './segmentsRulesTransform';
import template from './segmentsEdit.jade';
import FeatureFlagsHelper from '../../services/featureFlagsHelper';

export class SegmentsEditController {
  /* @ngInject */
  constructor(
    $stateParams,
    $state,
    SegmentsResource,
    SegmentPreviewResource,
    SegmentSizePreviewResource,
    SegmentTopCountriesPreviewResource,
    SegmentTopDevicesPreviewResource,
    GamesLimitedResource,
    notify,
    currentGame,
    currentUser,
    $scope,
    $filter,
    SegmentAnalyticsResource,
    SegmentAnalyticsBreakdownResource,
    featureFlagsHelper,
    CampaignsResource,
    GameAnalyticsResource,
    availableSegmentRulesLogicalFields
  ) {
    this.$stateParams = $stateParams;
    this.CampaignsResource = CampaignsResource;
    this.$state = $state;
    this.SegmentsResource = SegmentsResource;
    this.SegmentAnalyticsResource = SegmentAnalyticsResource;
    this.SegmentAnalyticsBreakdownResource = SegmentAnalyticsBreakdownResource;
    this.SegmentSizePreviewResource = SegmentSizePreviewResource;
    this.SegmentTopCountriesPreviewResource = SegmentTopCountriesPreviewResource;
    this.SegmentTopDevicesPreviewResource = SegmentTopDevicesPreviewResource;
    this.SegmentsRulesTransform = SegmentsRulesTransform;
    this.SegmentsDefinitionValidation = SegmentsDefinitionValidation;
    this.GameAnalyticsResource = GameAnalyticsResource;
    this.GamesLimitedResource = GamesLimitedResource;
    this.featureFlagsHelper = featureFlagsHelper;
    this.notify = notify;
    this.currentGame = currentGame;
    currentGame.subscribe(game => this.game = game);

    currentUser.subscribe((user) => {
      this.user = user;
    });

    this.availableSegmentRulesLogicalFields = availableSegmentRulesLogicalFields;
    this.segment = this.segment || {definition: {}};
    this.getRealSegmentSize = this.new === false;
    this.segment.preview = SegmentPreviewResource;
    this.form = {};
    this.translate = $filter('translate');
    this.shortNumber = $filter('shortNumber');
    this.apiDate = $filter('apiDate');
    this.showAdvancedTargetingText = this.translate('show') + ' ' + this.translate('advanced') + ' ' + this.translate('options');
    this.hideAdvancedTargetingText = this.translate('hide') + ' ' + this.translate('advanced') + ' ' + this.translate('options');
    this.allLogicOperators = ['$and', '$or', '$grouped_and', '$grouped_or'];

    this.isResourceBeingPersisted = false;
    this.gameDeveloperGames = [];
    this.getGameDeveloperGames();
    this.getRules();

    this.daterange = {
      startDate: getDateRanges().last30Days[0],
      endDate: getDateRanges().last30Days[1]
    };

    this.daterangeForPreview = {
      startDate: getDateRanges().yesterday[0],
      endDate: getDateRanges().today[1]
    };

    this.CampaignsResource.getList({game_id: this.$stateParams.gameId}).then((campaigns) => {
      _.remove(campaigns, (campaign) => { return campaign.type == 'Acquisition'; });
      this.campaigns = campaigns;
    });

    $scope.$watch("vm.rules", (newValue) => {
      if (newValue) {
        this.rulesChanged(newValue);
      }
    }, true);

    this.getTotalPlayersNumberForGame();

    this.enablePreviews = typeof this.enablePreviews === 'undefined' ? true : this.enablePreviews;
  }

  getGameDeveloperGames() {
    this.GamesLimitedResource.getList({game_developer_id: this.currentGame.value.game_developer_id}).then(games => {
      this.gameDeveloperGames = games;
    });
  }

  getTotalPlayersNumberForGame() {
    this.GameAnalyticsResource.one('players_count').get({game_id: this.currentGame.value.id})
      .then((result) => {
        this.segment.preview.total_size = result.players_count;
        if(this.segment.newAndPristine) { this.setSegmentSizeToTotalSize(); }
      })
  }

  setSegmentSizeToTotalSize() {
    this.segment.preview.segment_size = this.segment.preview.total_size;
  }

  getValidLogicOperators(rules) {
    const allLogicOperatorsClone = _.clone(this.allLogicOperators);
    if (!rules) {
      return allLogicOperatorsClone;
    }
    rules.forEach((rule, index) => {
      if (index === 0) {
        // the first rule has a default $and that is not used to build the segment definition
        // and that is not visible in the UI
        return;
      }
      if (rule.logical === '$grouped_and') {
        _.pull(allLogicOperatorsClone, '$and', '$grouped_or');
      } else if (rule.logical === '$grouped_or') {
        _.pull(allLogicOperatorsClone, '$or', '$grouped_and');
      } else if (rule.logical === '$and') {
        _.pull(allLogicOperatorsClone, '$or', '$grouped_and');
      } else if (rule.logical === '$or') {
        _.pull(allLogicOperatorsClone, '$and', '$grouped_or');
      }
    });

    return allLogicOperatorsClone;
  }

  rulesChanged(newValue) {
    this.hasMultipleGroupedOrGroups = this.SegmentsRulesTransform.hasMultipleGROUPED_ORBlocks(newValue);
    const validLogicOperators = this.getValidLogicOperators(newValue);
    newValue.forEach((rule, index) => {
      rule.validLogicOperators = validLogicOperators;
    });
    if (newValue) {
      if(newValue.length > 0) {
        this.setGroupingProperties(newValue);
        if(this.valid) {
          // Skip preview if any rule has no comparison operator selected yet
          // (user is mid-edit after adding a condition row). Without this guard,
          // toDefinition() emits malformed rules and the backend's
          // SegmentElasticSearchQueryBuilder.validateExpressionAndHandle throws
          // IllegalArgumentException -> 500. See PEP-15566.
          if (_.some(this.rules, (rule) => !rule.comparison)) {
            return;
          }
          let newDefinition = this.SegmentsRulesTransform.toDefinition(this.rules);
          if (this.SegmentsDefinitionValidation.isValidDefinition(newDefinition)) {
            this.segment.newAndPristine = false;
            this.getPreview(newDefinition, this.getRealSegmentSize);
            this.getRealSegmentSize = false;
          }
        }
      } else {
        this.setSegmentSizeToTotalSize();
      }
    }
  }

  setGroupingProperties(rules) {
    const foundGrouped = _.find((rules), (rule) => {
      return this.SegmentsRulesTransform.hasGroupedLogicalOperator(rule);
    });

    rules.forEach((rule, index) => {
      if(foundGrouped) {
        rule.isGrouped = true;
        rule.isFirstOfGroup = false;
        rule.isLastOfGroup = false;

        if (index === rules.length - 1) {
          // rule IS last --> last
          rule.isGrouped = true;
          rule.isLastOfGroup = true;
          if (!this.SegmentsRulesTransform.hasGroupedLogicalOperator(rule)) {
            // rulef i not grouped --> first
            rule.isFirstOfGroup = true;
          }
        } else {
          // rule NOT last
          if (!this.SegmentsRulesTransform.hasGroupedLogicalOperator(rule) && !this.SegmentsRulesTransform.hasGroupedLogicalOperator(rules[index + 1])) {
            //if rule not grouped AND index+1 not grouped --> first and last
            rule.isFirstOfGroup = true;
            rule.isLastOfGroup = true;
          } else if (!this.SegmentsRulesTransform.hasGroupedLogicalOperator(rule) && this.SegmentsRulesTransform.hasGroupedLogicalOperator(rules[index + 1])) {
            //if rule not grouped AND and index+1 grouped --> first
            rule.isFirstOfGroup = true;
          } else if (this.SegmentsRulesTransform.hasGroupedLogicalOperator(rule) && !this.SegmentsRulesTransform.hasGroupedLogicalOperator(rules[index + 1])) {
            //if rule grouped AND and index+1 NOT grouped --> last
            rule.isLastOfGroup = true;
          }
        }
      } else {
        delete rule.isGrouped;
        delete rule.isFirstOfGroup;
        delete rule.isLastOfGroup;
      }
    });
  }

  getPreview(definition, getRealSegmentSize) {
    if (!this.segment.preview)
      return;

    this.segment.preview.loading.size = true;
    this.segment.preview.loading.topCountries = true;
    this.segment.preview.loading.topDevices = true;
    if (!getRealSegmentSize && this.enablePreviews) {
      this.SegmentSizePreviewResource.post({game_id: this.currentGame.value.id, segment_id: this.segment.id, definition: definition})
        .then((preview) => {
          this.segment.preview.segment_size = preview.segment_size;
          this.segment.preview.loading.size = false;
          this.segment.preview.sizeAlreadyLoadedOnce = true;
        });
      this.SegmentTopCountriesPreviewResource.post({game_id: this.currentGame.value.id, definition: definition})
        .then((preview) => {
          this.segment.preview.stringifiedTopCountries = this.concatRowsValues(preview.top_countries_data.rows);
          this.segment.preview.loading.topCountries = false;
        });
      this.SegmentTopDevicesPreviewResource.post({game_id: this.currentGame.value.id, definition: definition})
        .then((preview) => {
          this.segment.preview.stringifiedTopDevices = this.concatRowsValues(preview.top_devices_data.rows);
          this.segment.preview.loading.topDevices = false;
        });
    } else if (getRealSegmentSize) {
      this.getSegmentSize(this.segment.id);
      this.getSegmentTopCountriesViaBreakdown(this.segment.id);
      this.getSegmentTopDevicesViaBreakdown(this.segment.id);
    }
  }

  getSegmentSize(id) {
    if(this.segment.type == 'engagement') {
      this.SegmentAnalyticsResource.one().get({
        segment_id: id,
        metric: 'size',
        start_date: this.apiDate(this.daterangeForPreview.startDate),
        end_date: this.apiDate(this.daterangeForPreview.endDate)
      }).then(res => {
        let values = _.chain(res).get('data.rows', []).map('value').value();
        this.segment.preview.segment_size = values[1] || values[0] || 0;
        this.segment.preview.loading.size = false;
        this.segment.preview.sizeAlreadyLoadedOnce = true;
      });
    }
  }

  getSegmentTopCountriesViaBreakdown(id) {
    if(this.segment.type == 'engagement') {
      this.SegmentAnalyticsBreakdownResource.one().get({
        segment_id: id,
        breakdown_dimension: 'top_countries',
        top_n: 3,
        start_date: this.apiDate(this.daterangeForPreview.startDate),
        end_date: this.apiDate(this.daterangeForPreview.endDate)
      }).then(res => {
        this.segment.preview.stringifiedTopCountries = this.concatRowsValues(res.breakdown_data);
        this.segment.preview.loading.topCountries = false;
      });
    }
  }

  getSegmentTopDevicesViaBreakdown(id) {
    if(this.segment.type == 'engagement') {
      this.SegmentAnalyticsBreakdownResource.one().get({
        segment_id: id,
        breakdown_dimension: 'top_platforms',
        top_n: 3,
        start_date: this.apiDate(this.daterange.startDate),
        end_date: this.apiDate(this.daterange.endDate)
      }).then(res => {
        this.segment.preview.stringifiedTopDevices = this.concatRowsValues(res.breakdown_data);
        this.segment.preview.loading.topDevices = false;
      });
    }
  }

  concatRowsValues(rows) {
    if (!rows.length) {
      return '-';
    } else {
      return _.map(rows, 'key').join();
    }
  }

  save() {
    this.isResourceBeingPersisted = true;
    this.segment.definition = this.SegmentsRulesTransform.toDefinition(this.rules);
    if (this.segment.id) {
      this.update();
    } else {
      this.create();
    }
  }

  create() {
    if(this.segment.type == 'engagement') {
      this.SegmentsResource.post(this.segment)
        .then((segment) => {
          segment.type = 'engagement';
          segment.isCtv = this.segment.isCtv;
          this.segments.push(segment);
          this.resetSegment();
          this.notify.created('segment', segment.name);
        })
        .catch(this.notify.apiError)
        .finally(() => {this.isResourceBeingPersisted = false});
    }
  }

  resetSegment() {
    this.segment = {
      game_id: this.segment.game_id,
      definition: {}
    };
    this.rules = [];
  }

  update() {
    this.segment.save()
      .then(() => {
        this.notify.updated('segment', this.segment.name);
        this.segment.editing = false;
        this.close && this.close();
      })
      .catch(this.notify.apiError)
      .finally(() => {this.isResourceBeingPersisted = false});
  }

  remove() {
    if (!this.hasDemoRole() || this.belongToYouappiGames()) {
      this.segment.deleted = true;
      this.segment.save()
        .then(() => {
          this.notify.removed('segment', this.segment.name);
          this.segments = _.without(this.segments, this.segment);
          this.$state.go('app.segments.index');
        })
        .catch(this.notify.apiError);
    }
  }

  get new() {
    return !this.segment.id;
  }

  get valid() {
    return this.form.$valid && this.rules.length;
  }

  getRules() {
    this.rules = this.SegmentsRulesTransform.toRules(this.segment.definition);
  }

  addRule() {
    this.rules.push({
      logical: 'unselected'
    });
  }

  hasDemoRole() {
    return this.user && this.user.id && this.user.hasRole && this.user.hasRole(['DEMO']);
  }

  belongToYouappiGames() {
    return this.currentGame.value.id === 1526 || this.currentGame.value.id === 1823;
  }
}

export function SegmentsEditComponent($timeout) {
  return {
    template,
    controller: SegmentsEditController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: {
      segment: '=',
      segments: '=',
      close: '&',
      enablePreviews: '<?'
    },
    link: (scope, element) => {
      _.map([100,200,300], (delay) => {
        $timeout(() => {
          scope.vm.segment.containerOffsetTop = $(element[0].parentElement.parentElement).offset().top;
        }, delay);
      });
    }
  };
}

export default angular.module('app.components.segments.edit', [
  ResourcesModule.name,
  LocalizationModule.name,
  ObservablesModule.name,
  FiltersModule.name,
  FeatureFlagsHelper.name
])
.directive('segmentsEdit', SegmentsEditComponent);



/** WEBPACK FOOTER **
 ** ./src/components/segments/segmentsEdit.js
 **/